export interface Profile {
  id?: number;
  external_id?: string;
  created_at?: string;
  modified_at?: string;
  is_deleted?: boolean;
  modified_by?: string;
  item_source_id?: number;
  in_report?: boolean;
  report_id?: number;
  parent_id?: number;
  manually_added?: boolean;
  content?: any;
  item_type_id?: number;
  is_reviewed?: boolean;
}

export interface ProfileValidationResponse {
  url: string;
  clean_url: string;
  valid: boolean;
  source: string;
  error: string;
}

export interface CreateProfileRequest {
  profile_url: string;
  report_uuid: string;
  actor_uuid: string;
}

export enum SCRAPE_TYPES {
  AUTO = "AUTO",
  MANUAL = "MANUAL",
  SKIP = "SKIP",
}

export enum SCRAPE_STATUS {
  TO_DO = "TO_DO",
  IN_PROGRESS = "IN_PROGRESS",
  DONE = "DONE",
  SKIPPED = "SKIPPED",
  FAILED = "FAILED", // Confirm if we are using the failed status for the scrapes
}

export interface UpdateProfileManualScrapeInput {
  profile: Profile;
  status: SCRAPE_STATUS;
}
